<div class="trends-card d-flex flex-column">
  <div class="flex-row header d-flex">
    <div class="title skeleton skeleton_animate"></div>
  </div>
  <div class="body d-flex flex-column" [ngStyle]="{ 'min-height': height + 'px' }">
    <div class="body-copy-skeleton skeleton skeleton_animate"></div>
    <div class="body-skeleton skeleton-still flex-grow-1"></div>
  </div>
</div>
